// extracted by mini-css-extract-plugin
export var banner = "categories-module--banner--MoZAJ";
export var layout = "categories-module--layout--W5ewx";
export var list = "categories-module--list--4ZrKy";